import { useQuery } from '@tanstack/react-query';
import { trackerAPI } from '../api/tracker.api';

export const useChronologicCommunications = (affaireId: number | null) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['chronologic-communications', affaireId],
    queryFn: async () => {
      console.log('[useChronologicCommunications] Fetching communications for affaireId:', affaireId);
      if (!affaireId) {
        return [];
      }
      const response = await trackerAPI.getChronologicCommunications(affaireId);
      console.log('[useChronologicCommunications] Received response:', response.success ? `${response.data.length} communications` : 'error');
      if (response.success) {
        return response.data;
      }
      throw new Error('Failed to fetch communications');
    },
    enabled: !!affaireId,
    staleTime: 0, // Always refetch on invalidation
  });

  return {
    communications: data || [],
    isLoading,
    error: error?.message || null,
    refetch
  };
};
